<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/116/title-bg.png" alt="" />
      <div class="technological-process">

        <div class="sxcl">
          <img class="top" src="./../assets/imgs/116/title-1.png" alt="" />
          <div class="content">
            龙泉驿区重点企业或科研院所（以下简称“重点单位”）新引进取得研究生学历学位的应届毕业生。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/116/title-2.png" alt="" />
          <div class="content">
            <div class="des">
              <div class="title">
                <div class="circle"></div>
                （一）申请人工作单位须为重点单位:
              </div>
              <span style="font-weight: bolder;">1．重点企业应满足以下条件：</span><br />
              （1）具有独立法人资格；<br /> （2）工商注册地和纳税关系在龙泉驿区；<br /> （3）属于龙泉驿区汽车主导产业和重点产业链的企业。<br />
              <span style="font-weight: bolder;">2．科研院所应满足以下条件：</span><br />
              （1）由市、区两级编制部门批复成立，具有独立法人资格；<br /> （2）驻地在龙泉驿区范围内（以法人证书写明地址为准）；<br />
              （3）主要从事基础和前沿技术研究、公益研究、应用研究和技术开发的科研院所及新型科研机构（不含驻区高校、中小学校和医疗机构及所属科研机构）。
            </div>
            <div class="des">
              <div class="title">
                <div class="circle"></div>
                （二）申请人应满足以下条件：
              </div>
              1．2022年7月后首次引进龙泉驿区；<br /> 2．取得全日制研究生学历和硕士及以上学位（国外高校取得的学历及学位必须经国家教育主管部门认证通过）的高校应届毕业生；<br />
              3．在毕业后24个月内到龙泉驿区重点单位工作（毕业时间以高校发放的学历学位证书注明的时间为准）；<br /> 4．与重点单位签订3年及以上劳动合同或聘用合同（合同签订单位须与社保缴纳单位一致）。
            </div>
            <div class="des">
              <div class="title">
                <div class="circle"></div>
                （三）申请时限:
              </div>
              申请人应于入职后的24个月内（以参保证明上注明的时间为准）按照龙泉驿区人社局年度通知规定时间内提出申请，逾期视为自动放弃申报资格。
            </div>

          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/116/title-3.png" alt="" />
          <div class="content">
            <div class="des" style="margin-top:1.2rem">
              <div class="title" style="align-items: flex-start;top:-1rem">
                <div class="circle" style="margin-right: 0.09rem;margin-top: 0.02rem;"></div>
                申请人可申请最长3年的生活补贴。标准如下：
              </div>
              （一）硕士生活补贴每人最高3万元，补贴标准为每年1万元；
            </div>
            <div class="des" style="margin-top:0.2rem;margin-bottom: 0.28rem;">
              （二）博士生活补贴每人最高10万元，补贴标准为第一年4万元、第二年3万元、第三年3万元。
            </div>
            <div style="color: #1F78FF;">生活补贴资金由研究生学历学位应届毕业生本人支配使用。</div>
          </div>
        </div>
        <div class="gmlc">
          <img class="top" src="./../assets/imgs/116/title-4.png" alt="" />
          <div class="content">
            <div class="title">
              <div class="circle"></div>
              <div class="font">
                研究生学历学位应届毕业生生活补贴实行年度集中申报，由研究生学历学位应届毕业生作为申请人进行申报。按以下程序办理：
              </div>
            </div>
            <div class="des mar-t3">
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">1</div>
                  <div class="line-title">个人申请</div>
                </div>
                <div class="line-content">
                  按照龙泉驿区人民政府官网年度申报通知要求，及时向所在重点单位申报。
                </div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">2</div>
                  <div class="line-title">单位上报</div>
                </div>
                <div class="line-content">
                  重点单位审查核实后将上年度符合享受优惠政策的人才情况进行汇总，向龙泉驿区人社局提交申报材料。
                </div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">3</div>
                  <div class="line-title">部门复审</div>
                </div>
                <div class="line-content">
                  龙泉驿区人社局会同相关部门对申报材料进行复审。</div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">4</div>
                  <div class="line-title">信息公示</div>
                </div>
                <div class="line-content">
                  复审通过的人员名单在龙泉驿区人民政府官网公示5个工作日。
                </div>
              </div>
              <div class="line-item">
                <div class="line"></div>
                <div class="line-top">
                  <div class="line-num">5</div>
                  <div class="line-title">会议审定</div>
                </div>
                <div class="line-content">
                  经公示无异议的，报龙泉驿区人社局党组会审议确定。
                </div>
              </div>
              <div class="line-item">
                <div class="line-top">
                  <div class="line-num">6</div>
                  <div class="line-title">拨付经费</div>
                </div>
                <div class="line-content">
                  审定通过后，龙泉驿区人社局按照补贴名单和标准，将生活补贴资金拨付到重点单位账户，研究生学历学位应届毕业生在重点单位工作满12个月后，由重点单位按年度一次性拨付到研究生学历学位应届毕业生本人账户。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img class="top" src="./../assets/imgs/116/title-5.png" alt="" />
          <div class="content" style="font-size: 0.3rem;font-weight: bolder;">
            依据每年度通知时间确定。
          </div>
        </div>
        
        <div class="contact">
          <img class="top" src="./../assets/imgs/116/title-6.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-84851306">028-84851306</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              区人社局专业技术人员管理科
            </div>
          </div>
        </div>
        <div class="codes">
          <img class="code" src="../assets/imgs/116/code.png" />
          <img class="text" src="../assets/imgs/116/text.png" />
        </div>
      </div>
    </section>
    <!-- <call phone="028-83221725"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() { },

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
    height: 5.6rem;
  }

  .technological-process {
    transform: translateY(-2.3rem);

    .rhtj {
      position: relative;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        text-align: left;
        line-height: 0.44rem;

        .font {
          background-color: #fff;
          border-radius: 0.2rem;
          padding: 0.28rem 0.31rem;
        }
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;
      font-size: 0.26rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #E8EEFF;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;

        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          margin-top: 0.9rem;
          position: relative;
          text-align: left;
          line-height: 0.44rem;

          color: #4E4E4E;
          font-size: 0.26rem;
          font-weight: normal;

          .title {
            font-weight: bold;
            position: absolute;
            top: -0.6rem;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            // height: 0.67rem;
            font-size: 0.3rem;

            // border: 1px solid red;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .circle {
              width: 0.22rem;
              height: 0.22rem;
              border: 0.06rem solid #FF6D60;
              border-radius: 50%;
            }
          }

        }
      }
    }

    .sbcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.34rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.1rem 0.23rem 0.3rem;
          position: relative;

          .item {
            margin-top: 0.35rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            color: #4E4E4E;
            font-size: 0.26rem;
            font-weight: 500;
            line-height: 0.44rem;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 135%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.1rem;
              top: 0.2rem;
              z-index: 0;

              //   background-color: #739bfe;
            }

            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.54rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;
      margin-bottom: 0.8rem;
      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }
      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        .title {
        font-weight: bold;
        // position: absolute;
        // top: -0.6rem;
        // left: 50%;
        // transform: translateX(-50%);
        width: 100%;
        // height: 0.67rem;
        font-size: 0.3rem;
        color: #333333;  
        // border: 1px solid red;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding-top: 0.39rem;
        .circle {
          width: 0.22rem;
          height: 0.22rem;
          border: 0.06rem solid #FF6D60;
          border-radius: 50%;
          margin-top: 0.05rem;
          margin-right: 0.1rem;
        }
        .font{
          flex: 1;
          text-align: left;
        }
      }
        // .title {
        //   font-size: 0.36rem;
        //   font-weight: bold;
        //   color: #333333;
        //   text-align: left;
        //   line-height: 0.5rem;
        // }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 100%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 3.31rem;
              height: 0.49rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.08rem;

              .line-num {
                width: 0.39rem;
                height: 0.39rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.14rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .code {
        width: 1.94rem;
        height: 1.94rem;
      }

      .text {
        height: 1.2rem;
      }
    }
  }
}</style>
